export default "__VITE_ASSET__BHB_ugkw__"